<template>
  <div>
    <SOOrdersTable :data="rows" :loading="isLoading" @refresh="fetchServiceOrders" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import { useFiltro } from '../../composables/useFiltro';
import { useSOOrders } from '../../composables/useSOOrders';
import SOOrdersTable from './SOOrdersTable.vue';

const { init } = useFiltro();
const { rows, isLoading, fetchServiceOrders } = useSOOrders();

const handleFilterUpdated = (): void => {
  log('SOOrdersPage', 'event:filter.updated', 'Received');
  fetchServiceOrders();
};

onMounted(() => {
  log('SOOrdersPage', 'mounted', 'Initializing filter and loading service orders');
  init();
  fetchServiceOrders();
  eventBus.on('filter.updated', handleFilterUpdated);
});

onBeforeUnmount(() => {
  log('SOOrdersPage', 'beforeUnmount', 'Cleaning up event listeners');
  eventBus.off('filter.updated', handleFilterUpdated);
});
</script>

<style scoped>
</style>
